import Application from "../../Application";
import VerificationPresenter, {
  IVerificationPresenter
} from "../../presenter/authentication/VerificationPresenter";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { IAuthenticationService } from "../../service/authentication/AuthenticationService";

export default class ShowVerificationPageInteractor {
  private application: Application;
  private credentialsService: ICredentialsService;
  private authenticationService: IAuthenticationService;
  private output?: IVerificationPresenter;

  constructor(application, credentialsService, authenticationService) {
    this.application = application;
    this.credentialsService = credentialsService;
    this.authenticationService = authenticationService;
  }

  execute(redirect?: string) {
    const username = this.credentialsService.getUsername();
    const password = this.credentialsService.getPassword();
    this.output = VerificationPresenter({
      application: this.application,
      initialState: {
        verificationCode: "",
        username,
        password,
        redirectRoute: redirect
      }
    });

    if (!username || !password) {
      this.authenticationService.logout();
      this.application.navigator.replace({
        pathname: "/login",
        search: redirect && `?redirect=${redirect}`
      });
    }

    return this.output;
  }
}
